import { Typography } from "@altify/components";
import { GradientOrColorView } from "components/GradientOrColorView/GradientOrColorView";
import { TooltipRenderProps } from "react-joyride";
import closeIcon from '../assets/close.svg';

export const tourSteps = [
    {
      target: '.insight-step',
      title: 'Get an Investing Edge With AI Insights',
      content: 'Learn exactly what’s driving your portfolio and asset prices.',
      pill: 'New',
      pillColor: '#B393FF',
      disableBeacon: true,
      placement: 'left-start' as const,
      offset: -40,
    },
  ];

export const tourStyles = {
    arrowColor: 'transparent',
    backgroundColor: '#ffffff',
    primaryColor: '#000000',
    textColor: '#000000',
    width: 360,
    zIndex: 1000,
  }

  export const TourStepTooltip = (props: TooltipRenderProps) => {
    const { backProps, closeProps, continuous, index, primaryProps, skipProps, step, tooltipProps } =
    props;

    return (
    <div className="tooltip__body flex flex-col bg-white p-4 rounded-3xl rounded-tl-none w-[260px] md:w-[360px] ml-4" {...tooltipProps}>
      <div className="tooltip__header mb-2 flex flex-row space-between">
        
         { // @ts-ignore 
          // TS is being ignored because step.pill is custom property we added
          step.pill && 
          <GradientOrColorView
            key={'step-' + index}
            colorOrGradient={
              // @ts-ignore 
              // TS is being ignored because step.pillColor is custom property we added
              step.pillColor
            }
            className="rounded-full mr-2 px-2 py-1 pr-4 font-normal h-fit self-center">
            <Typography
              size="medium" 
              weight='medium'
              className="text-black">
              { // @ts-ignore 
              // TS is being ignored because step.pill is custom property we added
                step.pill
              }
            </Typography>
          </GradientOrColorView>
        }
        {step.title && 
          <Typography 
            size="large" 
            weight='medium'
            className="tooltip__title text-black leading-tight">
            {step.title}
          </Typography>
        }
        <button className="tooltip__close self-start -mt-1" {...closeProps}>
          <img src={closeIcon} alt="clear-search" />
        </button>
      </div>
      <div className="tooltip__content">
        <Typography 
          size="large" 
          weight='regular'
          className="text-black leading-tight">
          {step.content}
        </Typography>
      </div>
    </div>
  );
  }